module.exports = __webpack_public_path__ + "img/bulldozer_h.0d7b727e.png";